import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { Tariff } from '../../models';
import { HttpClient } from '@angular/common/http';
import { CreateSurchargeRequest } from '../surcharge';
import { BoSpinnerService, BoToastrService } from '../../shared';
import { API } from '../config/api';
import { SUCCESS } from '../../../@shared/constants';
import { ErrorResponse, PaginationResponse } from '../config/common';
import { requestQuery } from '../../../@shared/untils';
import { PaginationTariffRequest, CreateTariffRequest } from './tariff.DTO';

@Injectable()
export class TariffService {
    constructor(
        private _http: HttpClient,
        private _spinner: BoSpinnerService,
        private _toastr: BoToastrService
        ) {}
    public getTariffs(request: PaginationTariffRequest): Observable<PaginationResponse<Tariff>> {
        return this._http.get<PaginationResponse<Tariff>>(`${API.TARIFF.GET_TARIFF}?${requestQuery(request)}`).pipe(tap(() => this._spinner.hide()));
    }
    public create(model: CreateTariffRequest) {
        return this._http.post(`${API.TARIFF.CREATE}`, model)
            .pipe(
                tap(() => {
                    this._toastr.successCode(SUCCESS.CREATE_TARIFF);
                }),
                catchError((err: ErrorResponse) => {
                    this._toastr.errors(err.error.errors);
                    throw err;
                })
            );
    }
    public updateTariffs(models: CreateTariffRequest[]) {
        return this._http.put(`${API.TARIFF.UPDATE_TARIFF}`, models)
            .pipe(
                tap(() => {
                    this._toastr.successCode(SUCCESS.UPDATE_TARIFF);
                }),
                catchError((err: ErrorResponse) => {
                    this._toastr.errors(err.error.errors);
                    throw err;
                })
            );
    }
    public delete(id:string) {
        return this._http.delete(API.TARIFF.DELETE(id))
            .pipe(
                tap(() => {
                    this._toastr.successCode(SUCCESS.DELETE_TARIFF);
                }),
                catchError((err: ErrorResponse) => {
                    this._toastr.errors(err.error.errors);
                    throw err;
                })
            )
    }
   
    public update(model: CreateTariffRequest, id: string) {
        return this._http.put(API.TARIFF.UPDATE(id), model);
    }
    public getTariffType(model: any) {
        return this._http.post(`${API.TARIFF.GET_TARIFF_TYPE}`, model);
    }
    public updateTariffBoxRate(model: any) {
        return this._http.put(`${API.TARIFF.UPDATE_TARIFF_BOX_RATES}`, model)
            .pipe(
                tap(() => {
                    this._toastr.successCode(SUCCESS.UPDATE_TARIFF_BOX_RATE);
                }),
                catchError((err: ErrorResponse) => {
                    this._toastr.errors(err.error.errors);
                    throw err;
                })
            );
    }
    public updateTariffPacketRate(model: any) {
        return this._http.put(`${API.TARIFF.UPDATE_TARIFF_PACKET_RATES}`, model)
            .pipe(
                tap(() => {
                    this._toastr.successCode(SUCCESS.UPDATE_TARIFF_PACKET_RATE);
                }),
                catchError((err: ErrorResponse) => {
                    this._toastr.errors(err.error.errors);
                    throw err;
                })
            );
    }
    public updateTariffSameDayRate(model: any) {
        return this._http.put(`${API.TARIFF.UPDATE_TARIFF_SAME_DAY_RATES}`, model)
            .pipe(
                tap(() => {
                    this._toastr.successCode(SUCCESS.UPDATE_TARIFF_SAME_DAY_RATE);
                }),
                catchError((err: ErrorResponse) => {
                    this._toastr.errors(err.error.errors);
                    throw err;
                })
            );
    }
    public updateTariffPalletRate(model: any) {
        return this._http.put(`${API.TARIFF.UPDATE_TARIFF_PALLET_RATES}`, model)
            .pipe(
                tap(() => {
                    this._toastr.successCode(SUCCESS.UPDATE_TARIFF_PALLET_RATE);
                }),
                catchError((err: ErrorResponse) => {
                    this._toastr.errors(err.error.errors);
                    throw err;
                })
            );
    }
}
